import { computed, Directive, input } from '@angular/core';
import { hlm } from '@spartan-ng/helm/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import type { ClassValue } from 'clsx';

export const cardVariants = cva(
  'bg-card text-card-foreground py-sm border-neutral-light gap-lg flex flex-col rounded-lg border',
  {
    variants: {
      variant: {
        default: '',
        destructive: 'border-feedback-negative-main',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);
export type CardVariants = VariantProps<typeof cardVariants>;

@Directive({
  selector: '[hlmCard]',
  host: {
    '[class]': '_computedClass()',
  },
})
export class HlmCard {
  public readonly userClass = input<ClassValue>('', { alias: 'class' });
  public readonly variant = input<CardVariants['variant']>('default');

  protected readonly _computedClass = computed(() => hlm(cardVariants({ variant: this.variant() }), this.userClass()));
}
